import React from 'react';
import PropTypes from 'prop-types';
import { useSlate } from 'slate-react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';

import { isBlockActive, isMarkActive, toggleBlock, toggleMark, isBlockFormat } from './editorUtils';

const useStyles = makeStyles(theme => ({
	toolbarButtonStyle: {
		padding: 8,
		color: theme.palette.text.disabled,
		'&.active': {
			color: theme.palette.text.primary
		}
	}
}));

export const ToolbarButton = ({ IconComponent, active, onClick, children }) => {
	const classes = useStyles();
	return (
		<IconButton
			classes={{ root: classes.toolbarButtonStyle }}
			onClick={onClick}
			className={`${active ? 'active' : ''}`}
		>
			<IconComponent color="inherit" />
			{children}
		</IconButton>
	);
};

ToolbarButton.propTypes = {
	children: PropTypes.element,
	IconComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.object]),
	active: PropTypes.bool,
	onClick: PropTypes.func
};

export const HistoryToolbarButton = ({ IconComponent, type = 'UNDO' }) => {
	const {
		history: { undos, redos },
		undo,
		redo
	} = useSlate();
	const active = (type === 'UNDO' ? undos : redos).length > 0;
	return (
		<ToolbarButton
			active={active}
			onClick={event => {
				event.preventDefault();
				if (type === 'UNDO') {
					undo();
				} else {
					redo();
				}
			}}
			IconComponent={IconComponent}
		/>
	);
};

HistoryToolbarButton.propTypes = {
	type: PropTypes.oneOf(['UNDO', 'REDO']),
	IconComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.object])
};

const AutoToolbarButton = ({ format, IconComponent }) => {
	const editor = useSlate();

	const { isActive, toggleElement } = React.useMemo(() => {
		const isBlock = isBlockFormat(format);
		return {
			isActive: isBlock ? isBlockActive : isMarkActive,
			toggleElement: isBlock ? toggleBlock : toggleMark
		};
	}, [format]);

	return (
		<ToolbarButton
			active={isActive(editor, format)}
			onClick={() => toggleElement(editor, format)}
			IconComponent={IconComponent}
		/>
	);
};

AutoToolbarButton.propTypes = {
	format: PropTypes.string,
	IconComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.object])
};

export default AutoToolbarButton;
